document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const toggleButton = document.querySelector('[data-toggle="filters"]')
    const sidebar = document.getElementById("cloud_search_filters_sidebar")
    const productContainer = document.querySelector("#MainContent div.page-collections")
    const toggleButtonMobile = document.querySelector(
      "a.cloud-search-page-controls__filters-link"
    )

    const filtersElement = document.querySelector("#cloud_search_filters_root")
    if (filtersElement && filtersElement.querySelector(".cloud-search-clear-filters")) {
      filtersElement.classList.add("has-clear-filters")
    }

    const appliedFilters = document.querySelector(".cloud-search-page-controls__applied-filters")

    if (toggleButton && sidebar) {
      toggleButton.addEventListener("click", () => {
        const isHidden = productContainer.classList.contains("filters-opened")
        !isHidden
          ? productContainer.classList.add("filters-opened")
          : productContainer.classList.remove("filters-opened")
        renameSortsInFilters()
      })
    }

    if (toggleButtonMobile) {
      toggleButtonMobile.addEventListener("click", () => {
        renameSortsInFilters()
      })
    }

    if (appliedFilters) document.querySelector("body").classList.add("search-results-page")

    renameSortsInFilters()
  }, 250)
})

function renameSortsInFilters() {
  const sortLabelsDesktop = document.querySelectorAll(
    '[data-filter-name="Sort by"] .cloud-search-filter-value'
  )

  const labelMap = {
    manual: "Relevance",
    "created-descending": "Newest",
    "best-selling": "Top sellers",
    "price-descending": "Price (High - Low)",
    "price-ascending": "Price (Low - High)",
  }

  sortLabelsDesktop.forEach(label => {
    const value = label.getAttribute("data-filter-value")
    if (labelMap[value]) {
      const nameSpan = label.querySelector(".cloud-search-filter-value__name")
      if (nameSpan) nameSpan.textContent = labelMap[value]
    } else {
      label.style.display = "none"
    }
  })
}

// Bind toggle button functionality
function bindToggleSizesButton() {
  const toggleButton = document.querySelector('[data-toggle="sizes"]')
  if (!toggleButton) return

  let sizesVisible = false

  toggleButton.addEventListener("click", () => {
    document.body.classList.toggle("sizes-visible", !sizesVisible)

    toggleButton.textContent = sizesVisible ? "Show sizes" : "Hide sizes"
    sizesVisible = !sizesVisible
  })
}

document.addEventListener("DOMContentLoaded", function () {
  bindToggleSizesButton()
})
